<template>
  <div :class="columnClassName">
    <column-header :activeLayout="activeLayout" :columns="columns" :columnIndex="columnIndex" :components="components" :activeComponent="component" v-on:setActiveComponent="setActiveComponent"></column-header>
    <div>
      <div class="row">
				<div class="col-md-12">
          <h3>{{ _('Shared order') }} {{ order.id }}</h3>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="orders" v-if="orders && orders.length">
            <h3>{{ _('Orders') }}</h3>
            <div class="table-responsive">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th width="115">{{ _('Order number') }}</th>
                    <th>{{ _('Shop ID') }}</th>
                    <th>{{ _('Price vat 0%') }}</th>
                    <th>{{ _('Price inc. vat') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="o in orders">
                    <td>{{ o.local_order_id }}</td>
                    <td>{{ o.shop_id }}</td>
                    <td>{{ $filters.currency(o.totalVatFree, settings.currency) }}</td>
                    <td>{{ $filters.currency(o.total, settings.currency) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6 rowspacing">
          <h3>{{ _('Summary') }}</h3>
          <table class="table">
            <tbody>
              <tr>
                <td width="50%">{{ _('Total (vat 0%)') }}</td>
                <td>{{ $filters.currency(order.totalVatFree, settings.currency) }}</td>
              </tr>
              <tr>
                <td width="50%">{{ _('Final price') }}</td>
                <td>{{ $filters.currency(order.total, settings.currency) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <nav class="save-bar">
      <div class="row">
        <div class="col-md-12">
          <div class="pull-right form-inline">
            <a class="btn btn-default" id="cancelButton" v-on:click="close"><i class="fa fa-fw fa-close"></i><span class="hidden-xs"> {{ _('Close') }}</span></a>
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>

import axios from 'axios'
import components from '~/lib/components'

export default {
  data () {
    return {
      order: {},
      orders: []
    }
  },
  mixins: [components],
  methods: {
    loadOrder (id) {
      return new Promise(async (resolve, reject) => {
        this.loading = true
        let response
        try {
          response = await axios.get(this.baseDomain + this.shopId + '/consolidatedorders/' + id + '.json?apikey=' + this.apiKey)
        } catch (e) {
          this.loading = false
          this.showError(e)
          reject()
          return
        }
        this.order = response.data
        try {
          response = await axios.get(this.baseDomain + this.shopId + '/consolidatedorders/' + id + '.json?orders=true&apikey=' + this.apiKey)
        } catch (e) {
          this.loading = false
          this.showError(e)
          reject()
          return
        }
        this.orders = response.data
        this.loading = false
        resolve(this.order)
      })
    }
  },
  async created () {
    if (this.component && this.component.initData) {
      try {
        await this.loadOrder(this.component.initData.orderId)
      } catch(e) {}
    }
  },
  async updated () {
    if (this.component && this.component.initData) {
      if (!this.deleted && (this.order && parseInt(this.order.id, 10) !== parseInt(this.component.initData.orderId, 10))) {
        try {
          await this.loadOrder(this.component.initData.orderId)
        } catch(e) {}
      }
    }
  }
}

</script>